export {
  useInterval,
  useTimeout,
  useMediaQuery,
  useDeviceDetection,
  useIsMobile,
  useIsTablet,
  useIsDesktop,
} from "@punchup/utils/hooks";
